import { Link, useLocation } from 'react-router-dom';
import { useFavoritesStore } from '@/stores/favorites';
import { BackHeader } from '@/components/BackHeader';

export function FavoritesPage() {
  const location = useLocation();
  const patientId =
    (location.state as { patientId?: string } | undefined)?.patientId ?? null;
  const favs = useFavoritesStore((s) => s.list);
  const remove = useFavoritesStore((s) => s.remove);

  function onRemove(name: string) {
    void remove(name);
  }

  return (
    <div className="p-4 flex flex-col gap-3 pb-24">
      <BackHeader title="Favoris" />
      {favs.length === 0 && (
        <p className="text-sm text-white/60">Aucun favori.</p>
      )}
      {favs.map((name) => (
        <div
          key={name}
          className="flex items-center justify-between bg-brand-dark/40 rounded-2xl p-3 shadow-card"
        >
          {patientId ? (
            <Link
              to={`/patient/${patientId}/acts/_/_/${encodeURIComponent(name)}`}
              className="flex-1 font-semibold"
            >
              {name}
            </Link>
          ) : (
            <span className="flex-1">{name}</span>
          )}
          <button
            onClick={() => onRemove(name)}
            className="text-sm text-red-300 ml-2"
          >
            Retirer
          </button>
        </div>
      ))}
    </div>
  );
}
